import {Migration} from '@mydocma/core/src/lib/migration';
import {IDBPDatabase} from 'idb';
import {MmProjectDbCollections} from '../../mm-project-db-schema';

export const V16: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.createObjectStore(MmProjectDbCollections.pools, { keyPath: 'Id' });
  },

};
